import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { Setting } from '../../classes/setting';
import { SettingsService } from '../../services/settings.service';
import { UserInfo, UserService } from '../../services/user.service';
import { SchoolYearPipe } from '../../pipes/schoolyear/schoolyear.pipe';

@Component({
    selector: 'app-admin-home',
    templateUrl: './admin-home.component.html',
    styleUrls: ['./admin-home.component.scss'],
    imports: [
        MatTooltipModule,
        CommonModule,
        SchoolYearPipe,
        MatIconModule,
        MatDividerModule,
        MatButtonModule,
        RouterModule
    ]
})
export class AdminHomeComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly settingSvc = inject(SettingsService);
    protected readonly userSvc = inject(UserService);
    user: UserInfo;
    schoolYearAdmin: Setting;
    schoolYearStudent: Setting;
    startDate: Setting;
    endDate: Setting;
    endDateDisplay: Setting;
    loading: boolean = true;

    ngOnInit() {
        this.user = this.userSvc.User;
        this.getSettings();
    }

    getSettings() {
        this.settingSvc.SettingsSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(settings => {
            if (settings == null) return;
            this.schoolYearAdmin = settings.find(f => f.Label === 'School year (scholarship admin)');
            this.schoolYearStudent = settings.find(f => f.Label === 'School year (scholarship entry)');
            this.startDate = settings.find(f => f.Label === 'Scholarship app start date');
            this.endDate = settings.find(f => f.Label === 'Scholarship app end date');
            this.endDateDisplay = settings.find(f => f.Label === 'Scholarship app end date (display)');
            this.loading = false;
        });
    }

}
